import { useMemo } from 'react';
import type { IteroOrder } from '../../../../../services/iteroBrowse';
import { safeHref } from '../../../../../utils/safeHref';
import { InlineError } from '../BrowserPrimitives';
import { BROWSE_FORMATTERS } from '../browseFormatters';
import { LINK_BUTTON_CLASS } from '../browserStyles';
import { FullRxSection } from '../FullRxSection';
import { MyIteroLink } from '../MyIteroLink';
import { FactTiles } from '../pane/FactTiles';
import { orderFactTiles } from './orderFacts';
import { OrderNotes, OrderTeeth } from './OrderTeethAndNotes';
import { ScansShortcut } from './ScansShortcut';

interface OrderDetailsTabProps {
    order: IteroOrder;
    refreshError: string | null;
    onRetryRefresh: () => void;
    onOpenScans: () => void;
}

export function OrderDetailsTab({
    order,
    refreshError,
    onRetryRefresh,
    onOpenScans
}: OrderDetailsTabProps) {
    const tiles = useMemo(() => orderFactTiles(order, BROWSE_FORMATTERS), [order]);
    return (
        <div className="flex flex-col gap-3 px-5 pb-6 pt-4">
            {refreshError && <InlineError message={refreshError} onRetry={onRetryRefresh} />}
            <FactTiles tiles={tiles} label="Order facts" />
            {safeHref(order.viewerUrl) && (
                <div className="-mt-1 flex justify-end">
                    <MyIteroLink
                        viewerUrl={order.viewerUrl}
                        className={`${LINK_BUTTON_CLASS} inline-flex items-center gap-1`}
                    />
                </div>
            )}
            <OrderNotes notes={order.notes} />
            <OrderTeeth order={order} />
            <FullRxSection rxId={order.rxId} />
            <ScansShortcut onOpen={onOpenScans} />
        </div>
    );
}
